import {
  AuthenticationResult,
  Configuration,
  EventMessage,
  EventType,
  RedirectRequest,
  SilentRequest,
  PublicClientApplication,
} from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    authority: process.env.AUTHORITY as string,
    clientId: process.env.CLIENT_ID as string,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const scopes = (process.env.SCOPE || '').split(',');

export const loginRedirectRequest: RedirectRequest = {
  scopes,
  prompt: 'select_account',
};

export const tokenRequest: Omit<SilentRequest, 'account'> = {
  scopes,
};

export const msalInstance = new PublicClientApplication(msalConfig);

const activeAccount = msalInstance.getActiveAccount();
const accounts = msalInstance.getAllAccounts();

if (!activeAccount && accounts.length === 1) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const { account } = payload;
    msalInstance.setActiveAccount(account);
  }
});
